export default [
  "Starter",
  "Route 1 (Gras)",
  "Septerna City (Geschenk)",
  "Traumbrache (Gras)",
  "Route 2 (Gras)",
  "Orion City (Geschenk)",
  "Route 3 (Gras)",
  "Kampfarena (Innen)",
  "Wald von Ewigenauen (Gras)",
  "Route 4 (Gras)",
  "Wüstenresort (Sand)",
  "Alter Palast (Innen)",
  "Route 16 (Gras)",
  "Freundesallee (Gras)",
  "Route 5 (Gras)",
  "Route 6 (Gras)",
  "Ferne Quelle (Innen)",
  "Zweiblattweg (Gras)",
  "Route 7 (Gras)",
  "Turm des Himmels (Innen)",
  "Kleopas-Ruinen (Innen)",
  "Route 8 (Gras)",
  "Moor von Panaero (Sumpf)",
  "Route 9 (Gras)",
  "Route 10 (Gras)",
  "Siegesstraße (Höhle)",
  "Pokémon-Liga",
  "Fossil-1",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];